import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GenerateBwUpdateRequest = (fileLocation, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GenerateBandwidthL18C2`,
	params: { fileLocation, userId }
});
